import React, { useEffect, useState, useRef } from "react";
import { observer } from "mobx-react-lite";
import { Link } from "react-router-dom";
import axios from "axios";

import Container from "react-bootstrap/Container";
// import { Button } from "react-bootstrap";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Image from "react-bootstrap/Image";
import LoadingComponent from "../../app/layout/LoadingComponent";

// import Form from "react-bootstrap/Form";
import { Form, Formik, Field } from "formik";
import { MySelectInput, MySelectInputControl } from "../../app/common/form/MySelectInput";

import Footer from "../Footer";
import "./src/css/convenios.css";

import { Button, Icon } from "semantic-ui-react";

import { calculoFechas } from "../../components/Portafolio/helpers/calculoFechas";

import addDepIcon from "../Convenios/src/imgs/plus-circle.svg";
import addDescIcon from "../Convenios/src/imgs/percent-circle.svg";

import ReactToPrint from "react-to-print";
import { useStore } from "../../app/stores/store";
import { RegionalBannerCentral } from "../Portafolio/Handlers/RegionalBannerCentral";
import { calculoFechasStandar } from "../Portafolio/helpers/calculoFechas";
import { MyTextAreatConv, MyTextAreatConvD, MyTextInputConv, MyTextInputConvD } from "../../app/common/form/MyTextInput";
import MyDateInput from "../../app/common/form/MyDateInput";
import { MyTextInputFechas } from "../../app/common/form/MyTextInput";
import UploadFileForm from "./Handlers/UploadFile";
import AproveConvFrm from "./Handlers/AproveConv";
import DetalleConvenios from "./DetalleConvenios";


export default observer(function DetalleConveniosFinanciero() {

  return (

    <>

      <RegionalBannerCentral />

        <Container className="detalle_convenio-area">
        
          <DetalleConvenios />

        </Container>

        <Footer />
    </>
        
  );
});

